import { render, staticRenderFns } from "./DataBurgerButton.vue?vue&type=template&id=1c83df2f&scoped=true&"
import script from "./DataBurgerButton.vue?vue&type=script&lang=js&"
export * from "./DataBurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./DataBurgerButton.vue?vue&type=style&index=0&id=1c83df2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83df2f",
  null
  
)

export default component.exports